export class GroupRepository {

    static getAll(type = null) {
        const allGroups = JSON.parse(localStorage.getItem("groups")) || [];
        if (type !== null) {
            return allGroups.filter(group => group.mode === type);
        }
        return allGroups;
    }


    static find(id) {
        const all = this.getAll();
        if (!all) return null;

        return all.find(item => item.id === id) || null;
    }


    static findByChatId(chatId) {
        const all = this.getAll();
        if (!all) return null;

        return all.find(item => parseInt(item.chat_id) === parseInt(chatId)) || null;
    }


    static deleteAll() {
        return localStorage.removeItem("groups")
    }

    static saveGroups(newGroups) {
        const existing = JSON.parse(localStorage.getItem("groups") || "[]");

        // Create a map from existing groups by chat_id
        const groupMap = new Map(existing.map(g => [g.chat_id, g]));

        newGroups.forEach(newGroup => {
            if (groupMap.has(newGroup.chat_id)) {
                // Merge existing and new group data
                groupMap.set(newGroup.chat_id, { ...groupMap.get(newGroup.chat_id), ...newGroup });
            } else {
                // Add new group
                groupMap.set(newGroup.chat_id, newGroup);
            }
        });

        const updatedGroups = Array.from(groupMap.values());
        localStorage.setItem("groups", JSON.stringify(updatedGroups));
    }


}
